<template>
    <div>
        <div class="banner" style="width:100%;">
            <div class="swiper-container" id="swiper-container">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="(ever,index) in lunboLI" :key="index" :style="{backgroundImage:'url(/static/img/'+ever+')'}"></div>
                </div>
                <!-- Add Pagination -->
                <div class="swiper-pagination"></div>
                <div class="swiper-over-img"></div>
            </div>
        </div>
        <!-- 新闻 start -->
        <div class="publishment">
            <span class="pb-icon">头条</span>
            <div class="pb-content">
                <div class="swiper-container" id="swiper-container-vertical">
                    <div class="swiper-wrapper hxcursor">
                        <div class="swiper-slide" v-for="(ever,index) in IndexNews.headlines" @click="toDetail(ever.new_id)" :key="index">{{ever.title}}</div> 
                    </div>
                </div>
            </div>
        </div>     
        <!-- 新闻 end --> 
        <!-- 新闻资讯 start -->
        <div class="new-bar bg-fff">
            <h3>
                新闻资讯
            </h3>
            <a href="#/newsList">更多</a>
        </div>
        <div class="news-list">
            <a href="javascript:;" @click="toDetail(item.new_id)" v-for="(item,index) in workList" :key="index">
                <h3>{{item.title}}</h3>
                <span>{{item.addtime}}</span>
            </a>
        </div>
        <!-- 新闻资讯 end -->
        <!-- 业务展示start -->
        <div class="yewu-title bg-fff mg-top-20" style="border-bottom:0;">
            <h3>
                业务展示
            </h3>
        </div>
        <div class="bg-fff overflow-h" style="padding-bottom: .2rem;">
            <!-- list -->
            <div class="yewu-zhanshi-list">
                <a href="javascript:;" v-for="(item,index) in four_show" :key="index" @click="toMassInfo(item.business_id)">
                    <img :src="baseUrl+item.cover">
                    <div class="yewu-zhanshi-content">
                        <h3>{{item.title}}</h3>
                        <p>{{item.desc}}</p>
                    </div>
                </a>
            </div>
            <!-- list end -->
            
        </div>
        <!-- 业务展示end -->
        
    </div>
</template>
<style>
    @import url('../assets/css/index.css');
    @import url('../assets/css/pubcss.css');
    @import url('../../node_modules/swiper/dist/css/swiper.css');

    /*轮播图*/
    .swiper-wrapper{ height:6.9rem; width:100%;}
    .swiper-slide{ background-size:auto 100%; background-repeat: no-repeat;}
</style>
<script>
    import Swiper from "swiper"
    export default {
        name:'Main',
        data(){
            return{
               lunboLI: ['banner-m-1.jpg','banner-m-2.jpg','banner-m-4.jpg'],
               IndexNews: '', //首页数据
               workList: '',
               baseUrl:'',
               four_show: '',//业务展示
               toutiaoTxt:['2018年北京精信嘉业建筑咨询有限公司受北京德源兴业投资管理有限公司中心委托，进行公开招标，欢迎合格的供应商前来投标。','123','456','哈哈哈哈哈哈'], 
            }
        },
        methods:{
            lunbo: function(){
                //首页banner轮播
                var mySwiper = new Swiper('#swiper-container', {
                    loop: true,
                    autoplay: true,
                    // disableOnInteraction : true,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                    }
                });
                mySwiper.el.onmouseover = function(){
                    mySwiper.autoplay.stop();
                }
                mySwiper.el.onmouseleave = function(){
                    mySwiper.autoplay.start();
                }
                //首页头条
                var mySwiper1 = new Swiper('#swiper-container-vertical', {
                    direction: 'vertical',
                    autoplay: true,
                    // loop: true,
                    // // delay: 1000,
                    observer:true,//修改swiper自己或子元素时，自动初始化swiper
                    observeParents:false,//修改swiper的父元素时，自动初始化swiper
                    onSlideChangeEnd: function(swiper){
                        swiper.update();
                        mySwiper1.startAutoplay();
                        mySwiper1.reLoop();
                    }
                });
                mySwiper1.el.onmouseover = function(){
                    mySwiper1.autoplay.stop();
                }
                mySwiper1.el.onmouseleave = function(){
                    mySwiper1.autoplay.start();
                }
            },
            getData: function(){
                var that = this;
                that.$http.post(that.baseUrl+that.config.news).then(function(ev){
                    if(ev.data.code == 100){
                        that.IndexNews = ev.data.data;//首页数据，对象
                        that.toutiaoTxt = ev.data.data.headlines;//头条新闻
                        that.workList = ev.data.data.work_list.slice(0,3);//新闻资讯
                    }
                }).catch(function(error){
                    console.log(error);
                })
                //业务展示
                that.$http.post(that.baseUrl+that.config.businessShow).then(function(ev){
                    if(ev.data.code == 100){
                        that.four_show = ev.data.data.slice(0,3);                        
                    }
                }).catch(function(error){
                    console.log(error);
                })
            },
            toDetail: function(new_id){
                this.$router.push({
                    name: 'newsContent',
                    params: {
                        new_id: new_id
                    }
                })
            },
            toMassInfo:function(business_id){
                this.$router.push({
                    name:"mainBusiness",
                    params:{
                        business_id:business_id
                    }
                });
            }
        },
        created(){
            
        },
        mounted(){
            this.baseUrl = window.baseUrl;
            this.config = window.config;
            this.getData();
            this.lunbo();
        }   
    }
</script>


// WEBPACK FOOTER //
// src/pages/Main.vue